module.exports = __webpack_public_path__ + "img/coupon-received.7acdfef3.png";